import { useNavigate, useRouteError } from "react-router-dom";

function Error() {
  const navigate = useNavigate();
  const error = useRouteError();
  console.log("Error: ", error);

  return (
    <div>
      <h1>Something happened</h1>
      <p>{error.data || error.message}</p>
      <button onClick={() => navigate(-1)}>&larr; Go Back</button>
    </div>
  );
}

export default Error;
